import { matchPath, useLocation } from "react-router";

import { getOrgSlug } from "@shared/utils";

import { useOrg } from "../useOrg";

/**
 * @returns the app base path for the current organization, or "/manage" if
 * there is no organization.
 */
export const useBasePath = () => {
  const { pathname } = useLocation();
  const [org] = useOrg();
  const orgPath = org ? `/orgs/${getOrgSlug(org)}` : null;

  const match = matchPath<{ orgName?: string }>(pathname, {
    path: "/orgs/:orgName",
  });

  return match?.params.orgName !== undefined
    ? `/orgs/${match.params.orgName}`
    : orgPath
    ? orgPath
    : "/manage";
};
